import {GetGlobalMonthlyGuildLeaderboardResponse, GuildsApi} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {useQuery} from "@tanstack/react-query";

async function fetchGlobalMonthlyGuildLeaderboard(leaderboardTimeParam: string): Promise<GetGlobalMonthlyGuildLeaderboardResponse> {
    return await new GuildsApi(getConfig()).getGlobalMonthlyGuildLeaderboard({leaderboardTimeParam});
}

function useGetGlobalMonthlyGuildLeaderboardQuery(leaderboardTimeParam: string, enabled: boolean) {
    return {
        queryKey: [
            "global-monthly-guild-leaderboard",
            leaderboardTimeParam,
        ],
        queryFn: () => fetchGlobalMonthlyGuildLeaderboard(leaderboardTimeParam),
        staleTime: 30 * 60000,
        enabled: !!leaderboardTimeParam && enabled,
    } as const;
}

export default function useGetGlobalMonthlyGuildLeaderboard(leaderboardTimeParam: string, enabled: boolean) {
    return useQuery(useGetGlobalMonthlyGuildLeaderboardQuery(leaderboardTimeParam, enabled));
}